module.exports = __webpack_public_path__ + "img/selected5-min.6c8e7e11.png";